import { RealEstate } from '../../../../@types/real-estate-api-types'
import { ContentStateInterface, SiteRecommendedUseTypes } from '../../../../@types/types'

export const siteRecommendedUseTypesToApp = (
  listing: RealEstate,
  defaultStateValues: ContentStateInterface
): SiteRecommendedUseTypes => ({
  noInformation:
    listing.details?.siteRecommendedUseTypes?.NO_INFORMATION ??
    defaultStateValues.siteRecommendedUseTypes?.noInformation,
  futureDevelopmentLand:
    listing.details?.siteRecommendedUseTypes?.FUTURE_DEVELOPMENT_LAND ??
    defaultStateValues.siteRecommendedUseTypes?.futureDevelopmentLand,
  twinHouse:
    listing.details?.siteRecommendedUseTypes?.TWINHOUSE ?? defaultStateValues.siteRecommendedUseTypes?.twinHouse,
  singleFamilyHouse:
    listing.details?.siteRecommendedUseTypes?.SINGLE_FAMILY_HOUSE ??
    defaultStateValues.siteRecommendedUseTypes?.singleFamilyHouse,
  garage: listing.details?.siteRecommendedUseTypes?.GARAGE ?? defaultStateValues.siteRecommendedUseTypes?.garage,
  garden: listing.details?.siteRecommendedUseTypes?.GARDEN ?? defaultStateValues.siteRecommendedUseTypes?.garden,
  noDevelopment:
    listing.details?.siteRecommendedUseTypes?.NO_DEVELOPMENT ??
    defaultStateValues.siteRecommendedUseTypes?.noDevelopment,
  apartmentBuilding:
    listing.details?.siteRecommendedUseTypes?.APARTMENT_BUILDING ??
    defaultStateValues.siteRecommendedUseTypes?.apartmentBuilding,
  orchard: listing.details?.siteRecommendedUseTypes?.ORCHARD ?? defaultStateValues.siteRecommendedUseTypes?.orchard,
  terraceHouse:
    listing.details?.siteRecommendedUseTypes?.TERRACE_HOUSE ?? defaultStateValues.siteRecommendedUseTypes?.terraceHouse,
  parkingSpace:
    listing.details?.siteRecommendedUseTypes?.PARKING_SPACE ?? defaultStateValues.siteRecommendedUseTypes?.parkingSpace,
  villa: listing.details?.siteRecommendedUseTypes?.VILLA ?? defaultStateValues.siteRecommendedUseTypes?.villa,
  forrest: listing.details?.siteRecommendedUseTypes?.FORREST ?? defaultStateValues.siteRecommendedUseTypes?.forrest,
  littleStore:
    listing.details?.siteRecommendedUseTypes?.LITTLE_STORE ?? defaultStateValues.siteRecommendedUseTypes?.littleStore,
  gastronomy:
    listing.details?.siteRecommendedUseTypes?.GASTRONOMY ?? defaultStateValues.siteRecommendedUseTypes?.gastronomy,
  business: listing.details?.siteRecommendedUseTypes?.BUSINESS ?? defaultStateValues.siteRecommendedUseTypes?.business,
  hotel: listing.details?.siteRecommendedUseTypes?.HOTEL ?? defaultStateValues.siteRecommendedUseTypes?.hotel,
  industry: listing.details?.siteRecommendedUseTypes?.INDUSTRY ?? defaultStateValues.siteRecommendedUseTypes?.industry,
  smallBusiness:
    listing.details?.siteRecommendedUseTypes?.SMALL_BUSINESS ??
    defaultStateValues.siteRecommendedUseTypes?.smallBusiness,
  stock: listing.details?.siteRecommendedUseTypes?.STOCK ?? defaultStateValues.siteRecommendedUseTypes?.stock,
  carPark: listing.details?.siteRecommendedUseTypes?.CAR_PARK ?? defaultStateValues.siteRecommendedUseTypes?.carPark,
  production:
    listing.details?.siteRecommendedUseTypes?.PRODUCTION ?? defaultStateValues.siteRecommendedUseTypes?.production,
  farmland: listing.details?.siteRecommendedUseTypes?.FARMLAND ?? defaultStateValues.siteRecommendedUseTypes?.farmland,
  moorage: listing.details?.siteRecommendedUseTypes?.MOORAGE ?? defaultStateValues.siteRecommendedUseTypes?.moorage,
  office: listing.details?.siteRecommendedUseTypes?.OFFICE ?? defaultStateValues.siteRecommendedUseTypes?.office,
  camping: listing.details?.siteRecommendedUseTypes?.CAMPING ?? defaultStateValues.siteRecommendedUseTypes?.camping,
  bigStore: listing.details?.siteRecommendedUseTypes?.BIG_STORE ?? defaultStateValues.siteRecommendedUseTypes?.bigStore,
})
